import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { MenuServices } from '../../../menu/services';

/**
 * Generated class for the MenuTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-tutorial-slide',
  templateUrl: 'menu-tutorial-slide.html',
})
export class MenuTutorialSlidePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public menuServices: MenuServices) {
  }

  ionViewDidLoad() {
  }

  ionViewDidLeave() {
    this.closeLeave();
  }

  close() {
    this.globals.restaurant.tutorial_menu = true;
    this.menuServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_menu': this.globals.restaurant.tutorial_menu,
    }).then(() => {
      this.navCtrl.pop();
    });
  }

  closeLeave(){
    this.globals.restaurant.tutorial_menu = true;
    this.menuServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tutorial_menu': this.globals.restaurant.tutorial_menu,
    }).then(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-slider/menu-tutorial-slide/menu-tutorial-slide.ts